import React from 'react';
import './how.css';

const HowItWorks: React.FC = () => {
  return (
    <section className="section" id="how">
      <div className="container">
        <h2 style={{ margin: '0 0 18px' }}>How it works</h2>
        <div className="grid steps">
          <div className="step"><div className="num">01</div><h3>Open a demo</h3><p>Get a virtual balance and practice with zero risk.</p></div>
          <div className="step"><div className="num">02</div><h3>Choose an asset</h3><p>FX, crypto, commodities or stocks — switch in seconds.</p></div>
          <div className="step"><div className="num">03</div><h3>Make a prediction</h3><p>Higher or lower by expiry — receive a fixed result.</p></div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
